export const userRoles = {
  Admin: 'Admin',
  Auditor: 'Auditor',
  FieldTechnician: 'Field Technician',
  DataScientist: 'Data Scientist',
  Analyst: 'Analyst',
  GISTechnician: 'GIS Technician',
}
